@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template-rows: max-content 1fr max-content;
}

.section {
  display: contents;
}

.basic,
.advanced {
  padding-block-start: 16px;
  block-size: 100%;
  overflow: auto;
}
.advanced {
  padding-block-end: 12px;
}

// basic
.basic {
  display: grid;
  grid-template:
    "runtime-environment runtime-environment" max-content
    "back-end front-end" 1fr;
  grid-template-columns: 1fr 1fr;
}
.basic__runtime-environment {
  grid-area: runtime-environment;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-gap-m);
}
.basic__runtime-environment.one-runtime-only {
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.dialog-header__back-end,
.dialog-header__front-end {
  padding-block-start: 16px;
}
.basic__back-end {
  grid-area: back-end;
}
.basic__front-end {
  grid-area: front-end;
}
.basic__back-end,
.basic__front-end {
  display: grid;
  grid-template-rows: max-content 1fr;
  grid-auto-rows: max-content;
  overflow: auto;
}
.main__back-end {
  border-inline-end: var(--section-common-border);
}
.main__back-end,
.main__front-end {
  grid-auto-rows: max-content;
  padding-block: 12px;
  overflow: auto;
}

// WA / TODO: Add a helper class in Mercury to justify text.
.text-align-center {
  text-align: center; // should be resolved on mercury
}

.tab::part(page) {
  // WA / TODO: Remove this line when the ch-tab renders supports scrollbar
  // custom styling
  scrollbar-width: thin;
}

// WA: Staring on Mercury V1.0.0. the checkbox displays an outline all around.
// This requires the checkbox inline-size to be set to max-content.
// TODO: Remove this once the checkbox displays correctly on a later version of Mercury.
.checkbox {
  inline-size: max-content;
}
